// General
export const LOADING = 'LOADING';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SET_TOKENS = 'SET_TOKENS';

export const LOGIN_STEP1_SUBMIT_NUMBER = 'LOGIN_STEP1_SUBMIT_NUMBER';
export const LOGIN_STEP2_SUBMIT_VERIFICATION_CODE = 'LOGIN_STEP2_SUBMIT_VERIFICATION_CODE';
export const FETCH_NUMBERS = 'FETCH_NUMBERS';
export const FETCH_HISTORY = 'FETCH_HISTORY';
export const FIND_NUMBER = 'FIND_NUMBER';
export const GET_STATUS = 'GET_STATUS';
export const MAKE_A_CALL = 'MAKE_A_CALL';
export const HANG_UP_A_CALL = 'HANG_UP_A_CALL';
export const SEARCH_BRIDGE_BY_NUMBER = 'SEARCH_BRIDGE_BY_NUMBER';
export const GET_ALL_BRIDGES = 'GET_ALL_BRIDGES';
export const GET_USER_HISTORY = 'GET_USER_HISTORY';
export const FETCH_DOMAIN_USERS = 'FETCH_DOMAIN_USERS';
export const GET_DOMAIN_USER = 'GET_DOMAIN_USER';
export const ADD_DOMAIN_USER = 'ADD_DOMAIN_USER';
export const EDIT_DOMAIN_USER = 'EDIT_DOMAIN_USER';
export const SAVE_DOMAIN_USER = 'SAVE_DOMAIN_USER';
export const DELETE_DOMAIN_USER = 'DELETE_DOMAIN_USER';
export const UPDATE_FEED_DESCRIPTION = 'UPDATE_FEED_DESCRIPTION';
export const GET_BRIDGE_BY_FEED_NUMBER = 'GET_BRIDGE_BY_FEED_NUMBER';
export const GET_STATUS_WITH_FEED_NUMBER = 'GET_STATUS_WITH_FEED_NUMBER';
export const SET_IS_POLLING_STATUS = 'SET_IS_POLLING_STATUS';
export const SET_API_ERROR_ACTION = 'SET_API_ERROR_ACTION';
export const HANG_UP_BRIDGE = 'HANG_UP_BRIDGE';

// CLEAN ALL
export const CLEAN_ALL = 'CLEAN_ALL';

export const CLEAN_UP_SEARCH_RES = 'CLEAN_UP_SEARCH_RES';
export const RE_DIAL = 'RE_DIAL';
